import React, { useEffect, useState } from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Snackbar from 'Snackbar';
import ConfirmDialog from '../components/ConfirmDialog/ConfirmDialog';

export const ProjectDetails = ({
  projectInfoVisible,
  project,
  projectUsageArea,
  projectUsageType,
  handleChange,
  handleBlur,
  confidential,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [projectInfoChecked, setProjectInfoChecked] = useState(false);

  const handleProjectInfo = state => {
    setProjectInfoChecked(state);
    handleChange(state);
    setOpenDialog(false);
  };

  useEffect(() => {
    if (projectInfoVisible !== undefined)
      setProjectInfoChecked(projectInfoVisible);
  }, [projectInfoVisible]);

  return (
    <Grid item xs={6} className="">
      <Grid container>
        <Grid item xs={6} className="slip-project-details">
          <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
            Project details
          </h2>
          <Grid container className="t-primary-1">
            <h3 className="t-primary-14 t-weight-b u-mrg-bot-10 u-mrg-top-10">
              {project.name}
            </h3>
            <p className="t-primary-13 u-mrg-bot-10">
              <b>Project number: </b> {project.uniqueProjectNumber}
            </p>
            <p className="t-primary-13 u-mrg-bot-10">
              <b>Project Business Area: </b>
              {projectUsageArea ? projectUsageArea.name : ''}
            </p>
            <p className="t-primary-13 u-mrg-bot-10">
              <b>Project Type: </b>
              {projectUsageType ? projectUsageType.name : ''}
            </p>
            <p className="t-primary-12 u-mrg-bot-10">Project description</p>
            <p className="t-primary-13">{project.description}</p>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <ConfirmDialog
            title="This project is marked confidential"
            open={openDialog}
            onConfirm={() => handleProjectInfo(true)}
            onCancel={() => setOpenDialog(false)}
          >
            Are you sure you want to include the project information with the
            supplier?
          </ConfirmDialog>
          {projectInfoVisible !== undefined ? (
            <FormControlLabel
              control={
                <Checkbox
                  name="projectInfoVisible"
                  checked={projectInfoChecked}
                  onClick={event =>
                    confidential
                      ? projectInfoChecked
                        ? handleProjectInfo(false)
                        : setOpenDialog(true)
                      : handleProjectInfo(event.target.checked)
                  }
                  onBlur={handleBlur}
                  value={String(projectInfoChecked)}
                />
              }
              label="Include project details"
            />
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};
